


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class InformationCardValues extends Vue {
  @Prop({ default: "fas fa-comment-medical" })
  icon!: string;

  @Prop({ default: null })
  title!: string;

  @Prop({ default: "#e68f00" })
  iconColor!: string;
}
